function switchImage(productId, imageSrc, sectionId, varantUrl) {
  $('#media-' + productId + ' img+img').attr('src', imageSrc);
  $(`#CardLink-${ sectionId }-${ productId }`).attr('href', varantUrl);
  // console.log(`${productId} switch product's img: ${imageSrc}`);
}

function openTab(event, tabName) {
  $('.tabcontent').hide();
  $('.tablinks').removeClass('active');
  $(`.tabcontent.${tabName}`).show();
  $(event.target).addClass('active');
}

function showMoreImages() {
  $('.product__media-wrapper').addClass('show-all');
  $('.product__media-show-more').hide();
}

function addFreeMonogram() {
  $('.btn-add-monogram').hide();
  $('.btn-add-monogram.remove').show();
  $('.product-form__buttons .inject').show(200);
  $('.monogram-image-container').show(200);
}

function removeFreeMonogram() {
  // refresh page to remove monogram
  location.reload();
}

/**
customized javascript in https://admin.shopify.com/store/zero-halliburton/apps/live-product-options

$('input[name="properties[Monogram]"]').on('change paste keyup', function() {
  const monogram = $(this).val();
  console.log(monogram);
  $('.monogram-text').text(monogram.toUpperCase());
});

$('input[name="properties[Monogram color]"]').change(function() {
  const monogram_color = $(this).val();
  const rgb_color = $(this).next('div.cl-po--swatch-color').css('background-color');
  console.log(monogram_color, rgb_color);
  $('.monogram-text').css('color', rgb_color);
});
*/



function zhShopifyLikeHandleize(str) {
  return String(str || '')
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function zhNormalizeAltSeparators(str) {
  return String(str || '').replace(/\u2013|\u2014|\u2212/g, '-');
}

function zhMediaAltColorKey(alt) {
  const trimmed = zhNormalizeAltSeparators(alt).trim();
  if (!trimmed) return '';
  const idx = trimmed.indexOf('-');
  if (idx !== -1) {
    return zhShopifyLikeHandleize(trimmed.slice(0, idx));
  }
  return zhShopifyLikeHandleize(trimmed.split(/\s+/)[0] || '');
}

function zhVariantOptionColorKey(opt) {
  const trimmed = zhNormalizeAltSeparators(opt).trim();
  if (!trimmed) return '';
  const idx = trimmed.indexOf('-');
  if (idx !== -1) {
    return zhShopifyLikeHandleize(trimmed.slice(0, idx));
  }
  return zhShopifyLikeHandleize(trimmed);
}

function zhVariantGalleryColorKey(variant) {
  if (!variant) return '';
  const raw =
    (variant.featured_media && variant.featured_media.alt) ||
    (variant.featured_image && variant.featured_image.alt) ||
    '';
  const fromAlt = zhMediaAltColorKey(raw);
  if (fromAlt) return fromAlt;
  const opt1 =
    variant.option1 ||
    (Array.isArray(variant.options) && variant.options.length > 0 && variant.options[0]) ||
    '';
  return zhVariantOptionColorKey(opt1);
}

function zhApplyVariantGalleryVisibility(variants) {
  const idInput =
    document.querySelector('product-info input.product-variant-id[name="id"]') ||
    document.querySelector('product-info input[name="id"]') ||
    document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (!idInput || !variants || !variants.length) return;
  const vid = String(idInput.value).trim();
  const variant = variants.find((v) => String(v.id) === vid);
  const prefix = zhVariantGalleryColorKey(variant);
  $('li.product__media-item').each(function () {
    const fullAlt = this.getAttribute('data-media-alt') || '';
    const slidePrefix = zhMediaAltColorKey(fullAlt);
    if (!prefix) {
      $(this).show();
      return;
    }
    if (slidePrefix === prefix) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function zhRunVariantGalleryFromDom() {
  const jsonEl = document.querySelector(
    'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
  );
  if (!jsonEl) return;
  let variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  zhApplyVariantGalleryVisibility(variants);
}

function zhActivateProductSpecUnit(root, unit) {
  if (!root || !unit) return;
  root.querySelectorAll('[data-product-spec-unit]').forEach(function (btn) {
    var active = btn.getAttribute('data-product-spec-unit') === unit;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-product-spec-unit-value]').forEach(function (el) {
    var active = el.getAttribute('data-product-spec-unit-value') === unit;
    if (active) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  });
}

$(function () {
  $(document).on('click', '[data-product-spec-unit]', function (event) {
    var btn = event.currentTarget;
    var root = btn.closest('[data-product-specs-init]');
    if (!root) return;
    event.preventDefault();
    zhActivateProductSpecUnit(root, btn.getAttribute('data-product-spec-unit'));
  });

  zhRunVariantGalleryFromDom();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      zhRunVariantGalleryFromDom();
    });
  }
});

